module.exports = __webpack_public_path__ + "img/SKWINKELNetActieEvaluatiesE2A637.4b1580fe.png";